export const standings = [
  {
    leagueId: 'nba',
    leagueName: 'NBA',
    rows: [
      { rank: 1, teamId: 'nba-lakers', win: 42, loss: 18, winRate: '70.0%', gb: '-', streak: '5连胜' },
      { rank: 2, teamId: 'nba-celtics', win: 40, loss: 20, winRate: '66.7%', gb: '2.0', streak: '3连胜' },
      { rank: 3, teamId: 'nba-warriors', win: 36, loss: 24, winRate: '60.0%', gb: '6.0', streak: '2连胜' },
      { rank: 4, teamId: 'nba-nuggets', win: 34, loss: 26, winRate: '56.7%', gb: '8.0', streak: '1负' },
      { rank: 5, teamId: 'nba-bucks', win: 32, loss: 28, winRate: '53.3%', gb: '10.0', streak: '2连胜' },
      { rank: 6, teamId: 'nba-suns', win: 30, loss: 30, winRate: '50.0%', gb: '12.0', streak: '1负' },
      { rank: 7, teamId: 'nba-heat', win: 28, loss: 32, winRate: '46.7%', gb: '14.0', streak: '3负' },
      { rank: 8, teamId: 'nba-mavericks', win: 27, loss: 33, winRate: '45.0%', gb: '15.0', streak: '1胜' },
    ],
  },
  {
    leagueId: 'cba',
    leagueName: 'CBA',
    rows: [
      { rank: 1, teamId: 'cba-liaoning', win: 38, loss: 8, winRate: '82.6%', gb: '-', streak: '6连胜' },
      { rank: 2, teamId: 'cba-guangdong', win: 35, loss: 11, winRate: '76.1%', gb: '3.0', streak: '4连胜' },
      { rank: 3, teamId: 'cba-zhejiang', win: 30, loss: 16, winRate: '65.2%', gb: '8.0', streak: '1负' },
      { rank: 4, teamId: 'cba-xinjiang', win: 27, loss: 19, winRate: '58.7%', gb: '11.0', streak: '2胜' },
    ],
  },
  {
    leagueId: 'euro',
    leagueName: 'EuroLeague',
    rows: [
      { rank: 1, teamId: 'euro-real', win: 24, loss: 6, winRate: '80.0%', gb: '-', streak: '8连胜' },
      { rank: 2, teamId: 'euro-olympiacos', win: 21, loss: 9, winRate: '70.0%', gb: '3.0', streak: '3连胜' },
      { rank: 3, teamId: 'euro-barca', win: 19, loss: 11, winRate: '63.3%', gb: '5.0', streak: '1负' },
      { rank: 4, teamId: 'euro-fener', win: 16, loss: 14, winRate: '53.3%', gb: '8.0', streak: '2负' },
    ],
  },
  {
    leagueId: 'wnba',
    leagueName: 'WNBA',
    rows: [
      { rank: 1, teamId: 'wnba-aces', win: 28, loss: 10, winRate: '73.7%', gb: '-', streak: '5连胜' },
      { rank: 2, teamId: 'wnba-liberty', win: 25, loss: 13, winRate: '65.8%', gb: '3.0', streak: '1负' },
    ],
  },
];